// extracted by css-extract-rspack-plugin
export default {"modal":"_33b50f2","dragArea":"_19301d3e"};